import axios from 'axios';
import { useEffect, useReducer } from 'react';

import API_ROUTES from 'config/apiRoutes';

import { Country } from '@maxmind/geoip2-node';

type GeoIpState = {
  status: string;
  countryCode: string | null;
  error: Error | null;
};

type GeoIpActionTypes =
  | { type: 'inProgress' }
  | { type: 'detected'; payload: string | null }
  | { type: 'error'; error: Error | null };

function geoIpReducer(state: GeoIpState, action: GeoIpActionTypes): GeoIpState {
  switch (action.type) {
    case 'inProgress':
      return {
        ...state,
        status: 'pending',
      };

    case 'detected':
      return {
        ...state,
        status: 'resolved',
        countryCode: action.payload,
      };

    case 'error':
      return {
        ...state,
        status: 'rejected',
        error: action.error,
      };

    default:
      throw new Error('Unhandled geoIpReducer action type');
  }
}

function useGeoIp(): GeoIpState {
  const [state, dispatch] = useReducer(geoIpReducer, {
    status: 'pending',
    countryCode: null,
    error: null,
  });

  useEffect(() => {
    dispatch({ type: 'inProgress' });
    axios
      .get<Country | null>(API_ROUTES.GEO_IP)
      .then((res) => {
        const countryCode = res.data?.country?.isoCode.toLowerCase() || null;
        dispatch({ type: 'detected', payload: countryCode });
      })
      .catch((err) => dispatch({ type: 'error', error: err }));
  }, []);

  return state;
}

export default useGeoIp;
